export const ACCEPT_FILE_TYPES = ['video/webm', 'video/mp4'];
